///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class TunnelConstants {
    public static readonly Z_INDEX = 500;
    public static readonly TUNNELS_QUANTITY = 16;
    public static readonly STROKE_OPACITY = 1;
    public static readonly STROKE_WEIGHT = 4;
    public static readonly COLORS = [
        '#B283F0',
        '#F83998',
        '#8AAF81',
        '#E08C11',
        '#2927BC',
        '#D35248',
        '#701662',
        '#9E5788',
        '#2D665A',
        '#87249F',
        '#ADAC16',
        '#3F5FA0',
        '#68262A',
        '#73EE3A',
        '#CA043F',
        '#C1C1C1'
    ];
}
